const mfaType = {
  sms: 'sms_twilio',
  yubikey: 'yubi',
  email: 'email',
  app: 'app',
};

export default mfaType;
